import { render, staticRenderFns } from "./disclaimer2.0.vue?vue&type=template&id=794264d1&scoped=true&"
import script from "./disclaimer2.0.vue?vue&type=script&lang=js&"
export * from "./disclaimer2.0.vue?vue&type=script&lang=js&"
import style0 from "./disclaimer2.0.vue?vue&type=style&index=0&id=794264d1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "794264d1",
  null
  
)

export default component.exports